export default __webpack_public_path__ + "media/greenHighlight.3d8e6174c02775fc099ca2ce747deb30.svg";